import state from "@/store/modules/modal/modalState";
import getters from "@/store/modules/modal/modalGetters";
import mutations from "@/store/modules/modal/modalMutations";
import actions from '@/store/modules/modal/modalActions';
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}